import { RecordStringAny } from 'components/core/dynamic-form/c1FormToYupSchema'
import { RenderBoolField } from 'components/core/dynamic-form/fields/bool/RenderBoolField'
import { RenderFileField } from 'components/core/dynamic-form/fields/file/RenderFileField'
import { RenderInt64Field } from 'components/core/dynamic-form/fields/int64/RenderIntField'
import { RenderStringField } from 'components/core/dynamic-form/fields/string/RenderStringField'
import { RenderStringSliceField } from 'components/core/dynamic-form/fields/string-slice/RenderStringSliceField'
import { Field } from 'pbts/c1/api/form/v1/form'
import { FC } from 'react'
import { ControllerRenderProps, FieldErrors } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

export type RenderFieldProps = {
    field: Field
    cField: ControllerRenderProps
    errors: FieldErrors<RecordStringAny>
    disabled: boolean
    onOauth2Authentication?: () => React.ReactElement
}

export const RenderField: FC<RenderFieldProps> = ({ field, cField, errors, disabled, onOauth2Authentication }) => {
    switch (field.type.oneofKind) {
        case 'stringField':
            return <RenderStringField field={field} cField={cField} errors={errors} disabled={disabled} />
        case 'stringSliceField':
            return <RenderStringSliceField field={field} cField={cField} errors={errors} disabled={disabled} />
        case 'boolField':
            return <RenderBoolField field={field} cField={cField} errors={errors} disabled={disabled} />
        case 'int64Field':
            return <RenderInt64Field field={field} cField={cField} errors={errors} disabled={disabled} />
        case 'fileField':
            return <RenderFileField field={field} cField={cField} errors={errors} disabled={disabled} />
        case 'oauth2Field':
            return onOauth2Authentication?.()
        default:
            return <UnknownField field={field} />
    }
}
type UnknownFieldProps = {
    field: Field
}

export const UnknownField: FC<UnknownFieldProps> = ({ field }) => <FormattedMessage
    id="dynamic_form_unsupported_field_type_view"
    defaultMessage="Unsupported field type/view for {field}"
    values={{ field: field.name }}
/>
